import { createAction } from "@reduxjs/toolkit";

export const UpdateLocale = createAction<string>("UPDATE_LOCALE");

export interface UpdateMessagesPayload { messages?: any; }
export const UpdateMessages = createAction<UpdateMessagesPayload>("UPDATE_MESSAGES");

export const UpdateLangPref = createAction<string>("UPDATE_LANG_PREF");